export const formatToHyphen = (payload: string): any => {
  let result = []
  if (payload) {
    for (let i = 0; i < payload.length; i++) {
      const element = payload[i]
      if (element === " ") {
        result.push("-")
      }
      if (element === "-") {
        result.push("_")
      }
      if (element === "_") {
        result.push("__")
      }
      if (element !== " " && element !== "-" && element !== "_") {
        result.push(element)
      }
    }
    return result.join("")
  }

  return payload
}

export const formatToSpaces = (payload: string): any => {
  let result = []
  if (payload) {
    for (let i = 0; i < payload.length; i++) {
      const element = payload[i]
      if (element === "-") {
        result.push(" ")
      } else if (element === "_") {
        result.push("-")
      } else if (element === "__") {
        result.push("_")
      } else if (element === " ") {
        result.push("-")
      } else {
        result.push(element)
      }
    }
    return result.join("")
  }

  return payload
}

export const truncateAddress = (walletStr: string | undefined) => {
  return walletStr
    ? walletStr.length > 7
      ? `${walletStr.slice(0, 6)}...${walletStr.slice(-5)}`
      : walletStr
    : ""
}

export const removeTrailingSlash = (url: string) => {
  return url.endsWith("/") ? url.slice(0, -1) : url
}

export function cls(...classNames: (string | null | undefined | false)[]) {
  const validClasses = classNames.filter((className) => !!className) as string[]
  return validClasses.join(" ")
}
